export function getFollowUpAnswersInitialState() {
    return {
        conversationId: '',
        conversationToken: '',
        isEnabled: false,
        followUpAnswers: [],
    };
}
export const createInitialFollowUpAnswer = (question) => ({
    question: question,
    isLoading: true,
    isStreaming: false,
    citations: [],
    liked: false,
    disliked: false,
    feedbackSubmitted: false,
    cannotAnswer: false,
    isActive: true,
    generationSteps: [],
});
